import { render, staticRenderFns } from "./invoiced-sales.vue?vue&type=template&id=3731bf17"
import script from "./invoiced-sales.vue?vue&type=script&lang=js"
export * from "./invoiced-sales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports